export const bonuses = [
  {
    number: 1,
    title: "The Gastrointestinal Physiology Visual Atlas",
    value: 19,
    image: "https://cdn.magicpatterns.com/uploads/pjY1ZCgcnE47bd4zf2iAsT/BONUS_1_GI_NUTRITION-EN.png",
    body: [
      "Understanding digestion requires connecting multiple organs, physiological processes, and nutrient-related concepts.",
      "I created this visual reference resource to help you organize those relationships through diagrams and structured summaries.",
    ],
    inside: [
      "Digestive system anatomy overview",
      "Digestive process diagrams",
      "Carbohydrate, protein, and fat digestion maps",
      "Nutrient absorption concept charts",
      "Gastrointestinal function reference sheets",
      "Digestive terminology guide",
      "Visual concept summaries",
      "Physiology review worksheets",
    ],
    note: "",
  },
  {
    number: 2,
    title: "The GI Nutrition Assessment Worksheet Collection",
    value: 17,
    image: "https://cdn.magicpatterns.com/uploads/pqQb6yte75oeKK1LJ5qtZj/BONUS_2_GI_NUTRITION-EN.png",
    body: [
      "This resource provides educational worksheets for organizing dietary histories, nutritional observations, and relevant assessment information.",
    ],
    inside: [
      "Gastrointestinal nutrition assessment preparation checklist",
      "Dietary history worksheet",
      "Food and symptom recording template",
      "Weight trend documentation form",
      "Dietary intake recording worksheet",
      "Nutrition risk review framework",
      "Relevant laboratory information organizer",
      "Nutrition assessment summary template",
    ],
    note: "These materials are designed for educational use and professional adaptation.",
  },
  {
    number: 3,
    title: "The Gastrointestinal Conditions Reference Atlas",
    value: 19,
    image: "https://cdn.magicpatterns.com/uploads/81mWhCpWxccUtUB4ZLCKLD/BONUS_3_GI_NUTRITION-EN.png",
    body: [
      "Gastrointestinal conditions involve different physiological processes, nutritional considerations, and educational priorities.",
      "This reference organizes foundational concepts associated with several gastrointestinal conditions.",
    ],
    inside: [
      "Irritable bowel syndrome educational overview",
      "Inflammatory bowel disease reference",
      "Malabsorption terminology guide",
      "Lactose digestion and intolerance concepts",
      "Overview of celiac disease and nutrient-related considerations",
      "Digestive symptom terminology",
      "Condition-specific educational reference summaries",
      "Clinical discussion preparation checklist",
    ],
    note: "This resource supports educational review and does not establish diagnoses or treatment recommendations.",
  },
  {
    number: 4,
    title: "The GI Nutrition Clinical Casebook",
    value: 17,
    image: "https://cdn.magicpatterns.com/uploads/vJtnMWje82GLT6E3u9iX9R/BONUS_4_GI_NUTRITION-EN.png",
    body: [
      "Case-based learning gives you an opportunity to organize information, identify relevant nutritional considerations, and review the reasoning involved in different educational scenarios.",
      "This casebook contains hypothetical gastrointestinal nutrition cases developed to support structured learning.",
    ],
    inside: [
      "Irritable bowel syndrome educational scenarios",
      "Inflammatory bowel disease nutrition cases",
      "Malabsorption-related educational cases",
      "Dietary assessment exercises",
      "Nutritional risk review scenarios",
      "Structured case analysis questions",
      "Nutrition assessment worksheets",
      "Case discussion frameworks",
    ],
    note: "The cases are educational examples, not validated clinical protocols or individualized treatment recommendations.",
  },
  {
    number: 5,
    title: "The GI Nutrition Documentation & Reference Toolkit",
    value: 19,
    image: "https://cdn.magicpatterns.com/uploads/cSiMoxFBrW7tLaJJSNGhVu/BONUS_5_GI_NUTRITION-EN.png",
    body: [
      "I wanted to include a practical resource to complement the main volumes with additional tools for organizing educational documentation and professional references.",
    ],
    inside: [
      "Nutrition consultation preparation templates",
      "Dietary intake monitoring forms",
      "Nutrition care plan review worksheets",
      "Weight trend tracking sheets",
      "Nutrition counseling documentation templates",
      "Follow-up assessment forms",
      "Nutrition intervention monitoring frameworks",
      "Reference tracking sheets",
      "Clinical case review documentation checklist",
    ],
    note: "Adapt all materials to your professional scope, privacy requirements, and applicable documentation standards.",
  },
];
